export default class EdgeSetIntersector {}
export default class EdgeSetIntersector {}
